"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingStatus = void 0;
var OnboardingStatus;
(function (OnboardingStatus) {
    OnboardingStatus["Complete"] = "complete";
    OnboardingStatus["Incomplete"] = "incomplete";
    OnboardingStatus["LegacyComplete"] = "legacy_complete";
    OnboardingStatus["LegacyIncomplete"] = "legacy_incomplete";
    OnboardingStatus["CompleteButWaitingForMdaToBeDownloaded"] = "complete_but_waiting_for_mda_to_be_downloaded";
})(OnboardingStatus = exports.OnboardingStatus || (exports.OnboardingStatus = {}));
//# sourceMappingURL=onboarding.js.map